export const calculateProfit = (
  revenue: number = 0,
  rent: number = 0,
  expenses: number = 0,
): number => revenue - rent - expenses;
